import './documents-management-view/documents-management-view.component';
import './documents-management-view/documents-management-view.scss';

import './pdf-form-template-select/pdf-form-template-select.component';
import './pdf-form-template-select/pdf-form-template-select.scss';

import './pdf-form-template-select-list/pdf-form-template-select-list.component';
import './pdf-form-template-select-list/pdf-form-template-select-list.scss';

import './pdf-form-templates-table/pdf-form-templates-table.component';
import './pdf-form-templates-table/pdf-form-templates-table.scss';

import './pdf-form-templates-table-row/pdf-form-templates-table-row.component';
import './pdf-form-templates-table-row/pdf-form-templates-table-row.scss';

import './pdf-form-text-tag-select/pdf-form-text-tag-select.component';
import './pdf-form-text-tag-select/pdf-form-text-tag-select.scss';
